import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { StockValueGraphView } from './StockValueGraphView'

export const StockValueGraph = () => {
    const [products, setProducts] = useState([])
    const [brands, setBrands] = useState([])
    const [suppliers, setSuppliers] = useState([])
    const [categories, setCategories] = useState([])
    const [selectedType, setSelectedType] = useState('brands')
    const [loading, setLoading] = useState(true)
    const [seriesData, setSeriesData] = useState([])
    const [lastUpdated, setLastUpdated] = useState()
    const [dates, setDates] = useState([])
    const [selectedDate, setSelectedDate] = useState([])
    const [initialLoad, setInitialLoad] = useState(false)


    //fetch local db 
    useEffect(() => {
        setLoading(true)
        axios.get(process.env.REACT_APP_HOST + 'api/reports/getProducts')
            .then((res) => {
                const date = new Date(res.data.products[0].qtyByDate[res.data.products[0].qtyByDate.length - 1][0][0])
                setLastUpdated(date)
                //const label = selectedType.slice(0,1).toUpperCase() + selectedType.slice(1, selectedType.length)
                setBrands(res.data.brands.map(product => product.value))
                setSuppliers(res.data.suppliers.map(product => product.value))
                setCategories(res.data.categories.map(product => product.value))
                filterByType(res.data.products, res.data[selectedType].map(product => product.value))
                if(!initialLoad){setDates(dateCheck(res.data.products))}
                setLoading(false)
                setInitialLoad(true)
            })

    }, [selectedDate], [selectedType],[])

    const dateCheck = (products) => {
        const productWithMostDates = products.reduce((acc, curr) => {
            if (curr.qtyByDate.length > acc.qtyByDate.length) {
                return curr;
            } else {
                return acc;
            }
        })
        console.log(productWithMostDates)
        const arr = []
        productWithMostDates.qtyByDate.forEach((x) => {
            arr.push(x[0][0])
        })
        setSelectedDate(arr[arr.length-1])
        return arr


    }

    const filterByType = (returnedProducts, cats) => {
        console.log(cats)
        const arr = []


        cats.forEach((subcat, index) => {
            arr.push(0)
            returnedProducts.forEach((product) => {
                if (subcat === product[parseCatName()]) {
                    const qty = product.qtyByDate.slice([-1])[0][0][1]
                    const test = findDate(product.qtyByDate)
                    arr[index] += (product.productCost * qty)

                }
            })
        })
        setSeriesData(arr)
    }

    const findDate = (dateArr) => {
        let found = []
        dateArr.forEach((arr) => {
            if(arr[0] === selectedDate){
                found = arr
            }
        })
        return found
    }

    const onSelectDimension = (e) => {
        setSelectedType(e.target.value)
    }

    const onSelectDates = (e) => {
        console.log('here', e.target.value)
        setSelectedDate(e.target.value)
        console.log(selectedDate)
        


    }

    const parseCatName = () => {
        if (selectedType === 'suppliers') {
            return 'supplierName'
        } else if (selectedType === 'brands') {
            return 'productBrand'
        } else if (selectedType === 'categories') {
            return 'productCategory'
        }
    }

    //then filter by date


    return <div><StockValueGraphView
        products={products}
        brands={brands}
        categories={categories}
        suppliers={suppliers}
        selectedType={selectedType}
        loading={loading}
        seriesData={seriesData}
        onSelectDimension={onSelectDimension}
        lastUpdated={lastUpdated}
        onSelectDates={onSelectDates}
        dates={dates}
        selectedDate={selectedDate}

    /></div>
}